import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "section-footer"
};
const _hoisted_2 = {
  class: "footer-bar-main"
};
const _hoisted_3 = ["href"];
const _hoisted_4 = ["href"];
const _hoisted_5 = ["href"];

const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "dropdown-menuafter"
}, null, -1);

const _hoisted_7 = {
  class: "mailbox"
};
const _hoisted_8 = {
  class: "footer-share-icon-div"
};
const _hoisted_9 = ["href"];

const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "footer-share-icon",
  src: "/moblie/images/footer-share-icon01.png"
}, null, -1);

const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = ["href"];

const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "footer-share-icon",
  src: "/moblie/images/footer-share-icon02.png"
}, null, -1);

const _hoisted_14 = [_hoisted_13];
const _hoisted_15 = ["href"];

const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  class: "footer-share-icon",
  src: "/moblie/images/footer-share-icon03.png"
}, null, -1);

const _hoisted_17 = [_hoisted_16];
const _hoisted_18 = {
  class: "footer-txt"
};

const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 备案号：蜀ICP备20014689号");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_backtop = _resolveComponent("el-backtop");

  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_cell = _resolveComponent("van-cell");

  const _component_van_collapse = _resolveComponent("van-collapse");

  const _component_van_field = _resolveComponent("van-field");

  const _component_van_button = _resolveComponent("van-button");

  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_collapse, {
    modelValue: $data.activeNames,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.activeNames = $event)
  }, {
    default: _withCtx(() => [_withDirectives(_createVNode(_component_el_backtop, {
      ref: "backtop",
      target: "#app"
    }, null, 512), [[_vShow, false]]), _createVNode(_component_van_cell, {
      class: "to-top",
      onClick: $options.toscrollTop
    }, {
      default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx._t('backTop')), 1), _createVNode(_component_van_icon, {
        class: "arrow-up-icon",
        name: "arrow-up"
      })]),
      _: 1
    }, 8, ["onClick"]), _createElementVNode("a", {
      href: _ctx.navText.about
    }, [_createVNode(_component_van_cell, {
      value: _ctx._t('about')
    }, null, 8, ["value"])], 8, _hoisted_3), _createElementVNode("a", {
      href: _ctx.navText.clause
    }, [_createVNode(_component_van_cell, {
      value: _ctx._t('clause')
    }, null, 8, ["value"])], 8, _hoisted_4), _createElementVNode("a", {
      href: _ctx.navText.problem
    }, [_createVNode(_component_van_cell, {
      value: _ctx._t('problem')
    }, null, 8, ["value"])], 8, _hoisted_5), _hoisted_6]),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_field, {
    placeholder: _ctx._t('enterEmail'),
    modelValue: $data.footermailtxt,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.footermailtxt = $event)
  }, null, 8, ["placeholder", "modelValue"]), _createVNode(_component_van_button, {
    type: "primary",
    onClick: _cache[2] || (_cache[2] = $event => $options.subscribeDo($data.footermailtxt))
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx._t('subscribe')), 1)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_8, [_createElementVNode("a", {
    href: _ctx.navText.flow_facebook
  }, _hoisted_11, 8, _hoisted_9), _createElementVNode("a", {
    href: _ctx.navText.flow_youtube
  }, _hoisted_14, 8, _hoisted_12), _createElementVNode("a", {
    href: _ctx.navText.flow_EDbbs
  }, _hoisted_17, 8, _hoisted_15)]), _createElementVNode("div", _hoisted_18, [_createTextVNode("Copyright © 2019 " + _toDisplayString(_ctx._t('winwing')) + " All Rights Reserved.", 1), _hoisted_19, _hoisted_20])])]);
}